/* tslint:disable */
/* eslint-disable */
/**
 * Internal Datadoc API
 * Service to maintain and expose metadata for data in Statistics Norway. Includes the following concepts:  - Data File: A logically defined blob of data from a file system or object storage. - Dataset: A collection of related Data Files which together represent a coherent dataset. These are typically partitioned by time periods. - Data Product: A collection of related Data Files that are produced and maintained by a Dapla team. All data which does not directly contribute to publication of a statistic on ssb.no is defined as a Data Product. - Statistic Product: A collection of related Data Files that are produced and maintained by a Dapla team, and directly contribute to publication of a statistic on ssb.no. The list of all statistic products is defined by the Statistic Register. 
 *
 * The version of the OpenAPI document: 0.1
 * Contact: metadata@ssb.no
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Describes the kind of Dapla bucket a data file is stored in.
 * @export
 */
export const StorageCategory = {
    SOURCE: 'SOURCE',
    PRODUCT: 'PRODUCT',
    SHARED: 'SHARED'
} as const;
export type StorageCategory = typeof StorageCategory[keyof typeof StorageCategory];


export function instanceOfStorageCategory(value: any): boolean {
    for (const key in StorageCategory) {
        if (Object.prototype.hasOwnProperty.call(StorageCategory, key)) {
            if (StorageCategory[key as keyof typeof StorageCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StorageCategoryFromJSON(json: any): StorageCategory {
    return StorageCategoryFromJSONTyped(json, false);
}

export function StorageCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorageCategory {
    return json as StorageCategory;
}

export function StorageCategoryToJSON(value?: StorageCategory | null): any {
    return value as any;
}

export function StorageCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): StorageCategory {
    return value as StorageCategory;
}

